// extracted by mini-css-extract-plugin
module.exports = {"container":"Tabs__container--c7t","tabs":"Tabs__tabs--1G1","tab":"Tabs__tab--JDU"};